export default __webpack_public_path__ + "static/menu-dont-light-b9594f417071a37b042b6a80721ff921.png";